import intersectLines from "../../utils/line-intersection";

const DRAW_EDGES = false;
const g_plane = new THREE.Line3();
const g_p1 = new THREE.Vector2(), g_p2 = new THREE.Vector2();

class ProceduralCanvasTexture extends THREE.CanvasTexture {
    constructor(size, flipOrder) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = canvas.height = size;


        super(
            canvas,
            undefined, undefined, undefined,
            THREE.LinearFilter, THREE.LinearFilter
        );

        this._flipOrder = flipOrder;
        this._size = size;
        this._context = ctx;
    }

    dispose() { return super.dispose(); }

    get context() { return this._context; }

    renderText({
        text: textToRender,
        segments, additionalLines,
        color, edgeColor, textColor,
        font, fontSize
    }) {
        const ctx = this.context, size = this._size, halfSize = size >> 1;
        const lines = [textToRender];

        let wasSplit;

        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = `${fontSize}px ${font}`;

        do {
            wasSplit = false;

            for (let i = 0, lineCount = lines.length, halfCount = lineCount >> 1; i < lineCount; i++) {
                const offsetY = (i - halfCount + (lineCount & 1 ? 0 : 0.5)) * fontSize / size;

                g_plane.start.set(-10.0, 0.5 - offsetY, 0);
                g_plane.end.set(10.0, 0.5 - offsetY, 0);

                const points = segments.reduce((accum, segment) => {
                    const [segA, segB] = segment;

                    const itsctA = intersectLines(segA, g_plane, g_p1) ? 1 : 0;
                    const itsctB = intersectLines(segB, g_plane, g_p2) ? 1 : 0;

                    accum.push([itsctA + itsctB, g_p1.x, g_p1.y, g_p2.x, g_p2.y]);

                    return accum;
                }, []).sort((a, b) => b[0] - a[0]);

                if (points.alength === 0) return;

                const [, x1, y1, x2, y2] = points[0];

                g_p1.set(x1, y1);
                g_p2.set(x2, y2);

                const distSqr = g_p1.distanceToSquared(g_p2) * (size ** 2);

                const line = lines[i];
                const metrics = ctx.measureText(`-${line}-`);
                const textSizeSqr = metrics.width ** 2;
                const fits = textSizeSqr < distSqr;

                if (!fits && line.includes(" ")) {
                    const wordSplit = line.split(" ");

                    for (let j = 0, wordLenght = wordSplit.length; j < wordLenght; j++) {
                        const line = wordSplit.slice(0, j + 1).join(" ");
                        const metrics = ctx.measureText(`-${line}- `);
                        const textSizeSqr = metrics.width ** 2;
                        const fits = textSizeSqr < distSqr;

                        if (!fits && line.includes(" ")) {
                            const line = wordSplit.slice(0, j).join(" ");
                            const otherWords = wordSplit.slice(j).join(" ");
                            const restSentence = lines.slice(i + 1).join(" ");
                            const combinedSentence = restSentence.length > 0 ? [otherWords, restSentence].join(" ") : otherWords;

                            lines[i] = line;
                            lines.splice(i + 1, lines.length - i, combinedSentence);

                            wasSplit = true;
                            break;
                        }
                    }

                    if (wasSplit) break;
                }
            }
        } while (wasSplit);

        ctx.beginPath();
        ctx.fillStyle = color;

        ctx.fillRect(0, 0, size, size);

        if (DRAW_EDGES) {
            ctx.beginPath();
            ctx.strokeStyle = edgeColor;
            ctx.lineWidth = 64;

            additionalLines.forEach(({ start, end }) => {
                ctx.moveTo(start.x * size, size - start.y * size);
                ctx.lineTo(end.x * size, size - end.y * size);
            });

            segments.forEach(lines => {
                lines.forEach(({ start, end }) => {

                    ctx.moveTo(start.x * size, size - start.y * size);
                    ctx.lineTo(end.x * size, size - end.y * size);
                });
            });

            ctx.stroke();
        }

        lines.forEach((line, index, arr) => {
            const lineCount = arr.length, halfCount = lineCount >> 1;
            const offsetY = (index - halfCount + (lineCount & 1 ? 0 : 0.5)) * fontSize;

            ctx.beginPath();
            ctx.fillStyle = textColor;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.font = `${fontSize}px ${font}`;
            ctx.fillText(line, halfSize, halfSize + offsetY);
        });

        this.needsUpdate = true;
    }
}

export default ProceduralCanvasTexture;
export { ProceduralCanvasTexture };